module.exports = __webpack_public_path__ + "img/border_large_braces.999a6a57.svg";